/**
 * Helper to get the localized version of an attribute
 * E.g. 'brand' -> 'brand.en-GB'
 */

export const getLocalizedAttribute = (attribute: string, locale: string): string => `${attribute}.${locale}`;
